import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroller';
import { Comment } from '../../utils';
import {
  Review,
  ReviewsPanel,
  ReviewGhost,
} from '../index';

import { ReviewsDropdownContainer } from "../ReviewsPanel";

import {
  ReviewsWrapper,
  ReviewsLayoutAside,
  ReviewsTwoColumnContainer,
  ReviewsContainer,
  ReviewsHeaderWrapper,
  ReviewsHeader,
  ReviewsTotalCount,
  ReviewsList,
  ReviewsNothingFound,
} from './styles';

class ReviewsPageLayout extends Component {
  static propTypes = {
    reviewsList: PropTypes.instanceOf(Array),
    hotels: PropTypes.instanceOf(Object),
    hotelData: PropTypes.instanceOf(Object),
    selectedHotel: PropTypes.instanceOf(Object),
    isTablet: PropTypes.bool,
    hasMore: PropTypes.bool,
    total: PropTypes.number,
    counter: PropTypes.number,
    handlePageScrollLoading: PropTypes.func,
  };

  state = {
    isOpen: false,
  };

  componentDidUpdate(prevProps) {
    const { reviewsList: oldReviewsList } = prevProps;
    const { reviewsList: newReviewsList } = this.props;

    if (JSON.stringify(oldReviewsList) !== JSON.stringify(newReviewsList)) {
      this.setState({
        isOpen: false,
      })
    }
  };

  toggleDropdown = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }));
  };

  render() {
    const { toggleDropdown } = this;
    const { isOpen } = this.state;
    const { reviewsList, hotels, hasMore, total, handlePageScrollLoading, selectedHotel, counter } = this.props;

    return (
      <ReviewsContainer>
        <ReviewsTwoColumnContainer>
          <ReviewsWrapper>
            <ReviewsHeaderWrapper>
              <ReviewsHeader>Reviews</ReviewsHeader>
              {total > 0 && (
                <ReviewsTotalCount>
                  <Comment />
                  <span>{total}</span> reviews for this Hotel
                </ReviewsTotalCount>
              )}
            </ReviewsHeaderWrapper>
            <ReviewsDropdownContainer selectedHotel={selectedHotel} hotels={hotels} toggleDropdown={toggleDropdown} dropdownOpened={isOpen} />
            {total > 0 ? (
              <InfiniteScroll
                pageStart={0}
                hasMore={hasMore}
                loadMore={handlePageScrollLoading}
                threshold={0}
                initialLoad={false}
                loader={(
                  <ReviewsList key="load">
                    <li>
                      <ReviewGhost />
                    </li>
                  </ReviewsList>
                )}
              >
                <ReviewsList>
                  {reviewsList.map(review =>(
                    <li key={review.id}>
                      <Review {...review} />
                    </li>
                  ))}
                </ReviewsList>
              </InfiniteScroll>
            ) : (
              <ReviewsNothingFound>No reviews</ReviewsNothingFound>
            )}
          </ReviewsWrapper>
          <ReviewsLayoutAside hasSelectedHotel={selectedHotel}>
            <ReviewsPanel selectedHotel={selectedHotel} hotels={hotels} toggleDropdown={toggleDropdown} dropdownOpened={isOpen} counter={counter} />
          </ReviewsLayoutAside>
        </ReviewsTwoColumnContainer>
      </ReviewsContainer>
  )};
}

const mapStateToProps = state => ({
  userInfo: state.user.userData,
});

export default connect(mapStateToProps)(ReviewsPageLayout);
